import { useState, useEffect } from "react";

//import Wheel from "@uiw/react-color-wheel";
import Circle from "@uiw/react-color-circle";

import Stack from "@mui/material/Stack";
import Popper from "@mui/material/Popper";

import IconButton from "@mui/material/IconButton";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";

import ShortCutLabelsForm from "../features/labels/ShortCutLabelsForm";

function IconButtons(props) {
  const [isPinIconClicked, setPinIconClick] = useState(props.pinStatus);
  const [hex, setHex] = useState(props.bgCol);
  const [isColClicked, setColClick] = useState(false);
  const [openLabelsList, setOpenLabelsList] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  function pinClicked() {
    setPinIconClick(!isPinIconClicked);
    props.onPinClick(!isPinIconClicked);
  }
  function pickingColour() {
    setColClick(!isColClicked);
  }
  function handleColour(colour) {
    setHex(colour.hex);
    props.onBgColourClick(colour.hex);
  }
  function labelsListClicked(event) {
    setOpenLabelsList(true);
    setAnchorEl(event.currentTarget);
  }
  function handleClickAway() {
    setOpenLabelsList(false);
    setAnchorEl(false);
  }
  useEffect(() => {
    setHex(props.bgCol);
    setPinIconClick(props.pinStatus);
  }, [props.pinStatus, props.bgCol]);

  return (
    <div>
      {isColClicked && (
        <Circle
          colors={[
            "#435B66",
            "#A76F6F",
            "#5C8984",
            "#545B77",
            "#99627A",
            "#967E76",
            "#C1D0B5",
            "#674188",
            "#BA94D1",
            "#C55300",
          ]}
          color={hex}
          onChange={(colour) => {
            handleColour(colour);
          }}
        />
      )}
      <Stack direction="row" spacing={1}>
        <IconButton aria-label="pin" size="small" onClick={() => pinClicked()}>
          {isPinIconClicked ? <PushPinIcon /> : <PushPinOutlinedIcon />}
        </IconButton>
        <IconButton aria-label="colorLens" size="small" onClick={pickingColour}>
          <ColorLensOutlinedIcon />
        </IconButton>
        <IconButton
          aria-label="label"
          size="small"
          onClick={(e) => labelsListClicked(e)}
        >
          <LabelOutlinedIcon />
        </IconButton>
      </Stack>
      {openLabelsList && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Popper open={openLabelsList} anchorEl={anchorEl}>
            <ShortCutLabelsForm
              authorId={props.authorId}
              handleCheckedLabels={props.handleCheckedLabels}
              labels={props.labelsList}
            />
          </Popper>
        </ClickAwayListener>
      )}
    </div>
  );
}

export default IconButtons;
